import { http } from 'services/http';
import { DOCUMENTS_GET_MANY } from 'api/query-keys.ts';
import type { DocumentSignedUrlRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useGenerateInvoice = (invoiceId: number) => {
  return useMutationBase<DocumentSignedUrlRes, unknown>({
    mutationFn: async () => {
      const res = await http.post<DocumentSignedUrlRes>(`/v1/invoices/${invoiceId}/pdf`);

      return res.data;
    },

    invalidateCallback: () => [[DOCUMENTS_GET_MANY]],
  });
};
